var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagePadding"},[_c('Table',{attrs:{"productList":_vm.listColumns,"productData":_vm.listData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }